import { render } from "./Order.vue?vue&type=template&id=7c5894d5&scoped=true"
import script from "./Order.vue?vue&type=script&setup=true&lang=js"
export * from "./Order.vue?vue&type=script&setup=true&lang=js"

import "./Order.vue?vue&type=style&index=0&id=7c5894d5&scoped=true&lang=scss"

import exportComponent from "/home/runner/work/linker-marketplace-web/linker-marketplace-web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7c5894d5"],['__file',"resources/js/components/whatsapp-managment/includes/Profile/Order.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "7c5894d5"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('7c5894d5', __exports__)) {
    console.log('reload')
    api.reload('7c5894d5', __exports__)
  }
  
  module.hot.accept("./Order.vue?vue&type=template&id=7c5894d5&scoped=true", () => {
    console.log('re-render')
    api.rerender('7c5894d5', render)
  })

}


export default __exports__